import React from "react";
import Card from "../CardDashboard/Card";
import { useLanguage } from "../LangTranslation/LanguageContext";

const MarketingCards = ({
  currencySymbol = "$",
  profitLoss = {},
  totalIncome = {},
  totalExpense = {},
  unreconciledItems = 0,
}) => {
  const { language, translations } = useLanguage();
  const t = translations[language];
  const getDecimalValue = (value) => (Math.abs(value) || 0).toFixed(2);
  const cardsData = [
    {
      title: "Net Profit or loss",
      value: `${getDecimalValue(profitLoss?.monthly)}${currencySymbol} `,
      change: "3.48%",
      since: `This year ${getDecimalValue(
        profitLoss?.annual
      )}${currencySymbol} `,
    },
    {
      title: "Total Income",
      value: `${getDecimalValue(totalIncome?.monthly)}${currencySymbol} `,
      change: "-3.48%",
      since: `This year ${getDecimalValue(
        totalIncome?.annual
      )}${currencySymbol} `,
    },
    {
      title: "Total Expense",
      value: `${getDecimalValue(totalExpense?.monthly)}${currencySymbol} `,
      change: "-2.10%",
      since: `This year ${getDecimalValue(
        totalExpense?.annual
      )}${currencySymbol} `,
    },
    {
      title: "Unreconciled items",
      value: `${unreconciledItems.monthly || 0} Items `,
      change: "12%",
      since: `This year ${unreconciledItems?.annual || 0} Items `,
    },
  ];
  return (
    <>
      <div
        className="me-2 mb-2 "
        style={{
          fontFamily: "Inter",
          fontSize: "18px",
          color: "#323B4B",
          fontWeight: 600,
        }}
      >
        {t["Overview"]}
      </div>
      <div className="row px-2">
        {cardsData.map((card, index) => (
          <div className="col-xl-3 col-lg-6" key={index}>
            <Card
              title={t[card.title]}
              value={card.value}
              change={card.change}
              since={card.since}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default MarketingCards;
